import { inject, Pipe, PipeTransform } from '@angular/core';
import { appendToRmaCdnUrl } from '@rma/generic/ng/util';

@Pipe({
  name: 'cdnUrl',
  standalone: true,
})
export class CdnUrlPipe implements PipeTransform {
  private readonly cdnUrl = inject(appendToRmaCdnUrl);

  public transform(value: string): string {
    return this.cdnUrl(value);
  }
}
